module.exports = __webpack_public_path__ + "media/img/Scholarships2u-Logo-Icon-7d3f41affeb608ab2881536018bbc883.svg";